import React from "react";
import "../css/contactus.scss";

function Contact() {
  return (
    <main className="contact-page">
      <section className="contact-hero">
        <p className="contact-kicker">CONTACT</p>
        <h1>Say hello.</h1>
        <p>For catalogue, accessibility, privacy or rights enquiries, contact us by email.</p>
        <a href="mailto:track@uightparcel.shop">track@uightparcel.shop</a>
      </section>
      <section className="contact-guidance">
        <h2>What to include</h2>
        <ul>
          <li>A clear subject line and a short description of your enquiry.</li>
          <li>For an intellectual property report, include the page URL and evidence described in our takedown policy.</li>
          <li>For accessibility feedback, tell us the page and assistive technology or browser used, if relevant.</li>
        </ul>
        <p><strong>Please do not email passwords, card numbers, security codes or identity documents unless we specifically request a secure verification method.</strong></p>
        <p>This website does not contain a submission form; selecting the email link opens your own email application.</p>
      </section>
    </main>
  );
}

export default Contact;
